<div style="width: 100%;" class="d-flex justify-content-center">
    <H3 [@openClose]="isTitleOpen ? 'open' : 'closed'" class="text-center"
    (@openClose.done)="onOpenCloseDone($event)">Coucou Pierre!</H3>
</div>
<div style="width: 100%;" class="d-flex align-items-center justify-content-center">
    <div class="rounded" [@openCloseImage]="isImageOpen ? 'open' : 'closed'"(@openCloseImage.done)="onOpenCloseDone($event)">
        <img src="./assets/images/YMO.jpg" style="display: block; width: 100%; height: 100%; object-fit:contain; ">
    </div>
    <div [@openCloseMessage]="isMessageOpen ? 'open' : 'closed'" class="d-flex align-items-center justify-content-center">
        <div style="width:120px;"><HR></div>
        <H4 flex class="form-control">{{Message}}</H4>
    </div>
    
</div>